import React from "react";
import { IoMdPin } from "react-icons/io";

export interface MapMarkerProps {
  orderNumber: string;
  lat: number;
  lng: number;
  className: string;
}

export function MapMarker(props: MapMarkerProps) {
  const { orderNumber, className } = props;

  return (
    <div className={`map-marker-component ${className}`}>
      <IoMdPin className="pin" />

      <div className="text-conatiner">
        <div className="text">{orderNumber}</div>
      </div>
    </div>
  );
}
